import { provideZoneChangeDetection } from '@angular/core';
import { Settings } from 'luxon';

export function provideLocale() {
  // Configura Luxon en español de Argentina (es-AR) y timezone
  Settings.defaultLocale = 'es-AR';
  Settings.defaultZone = 'America/Argentina/Buenos_Aires';

  return [
    provideZoneChangeDetection({ eventCoalescing: true }),
  ];
}